import React from 'react';
import styles from './styles.module.css';
import Image from 'next/image';
import { teamData } from '../teamData';
import Link from 'next/link';
import { Icon } from 'common/icon';
import { Routes } from 'constants/routes';

export const OurTeamCards = () => {
  return (
    <div className={styles.container}>
      {teamData.map((author, index) => (
        <Link
          href={Routes.aboutThisAuthor(author.name)}
          key={index}
          className={styles.card}
        >
          <div className={styles.cardContent}>
            <div className={styles.avatarContainer}>
              <div className={styles.avatar}>
                <div className={styles.profileImageContainer}>
                  <Image
                    width={70}
                    height={70}
                    src={author.imageUrl || ''}
                    alt={`Profile picture of ${author.name}`}
                    className={styles.profileImage}
                  />
                </div>
              </div>
            </div>
            <div className={styles.authorInfo}>
              <div className={styles.nameRole}>
                <span className={styles.name}>{author.name}</span>
                <div className={styles.divider} />
                <span className={styles.role}>{author.position}</span>
              </div>
            </div>
          </div>
          <div className={styles.moreButton}>
            <span className={styles.moreAbout}>More about the author</span>
            <Icon.Arrow width={16} height={16} />
          </div>
        </Link>
      ))}
    </div>
  );
};
